<template>
  <div style="margin-top:30px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="110px">
      <el-form-item label="访问地址">
        <a :href="agreementUrl + 7" target="_blank" rel="noopener noreferrer">{{
          agreementUrl + 7
        }}</a>
      </el-form-item>
      <el-form-item
        label="托运人隐私协议"
        prop="privacyAgreementShipper"
        style="margin-right:15px"
      >
        <myEditor v-model="form.privacyAgreementShipper" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a :href="agreementUrl + 8" target="_blank" rel="noopener noreferrer">{{
          agreementUrl + 8
        }}</a>
      </el-form-item>
      <el-form-item
        label="托运人服务协议"
        prop="userAgreementShipper"
        style="margin-right:15px"
      >
        <myEditor v-model="form.userAgreementShipper" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a
          :href="agreementUrl + 10"
          target="_blank"
          rel="noopener noreferrer"
          >{{ agreementUrl + 10 }}</a
        >
      </el-form-item>
      <el-form-item
        label="物流运输协议"
        prop="logisticsAgreementShipper"
        style="margin-right:15px"
      >
        <myEditor v-model="form.logisticsAgreementShipper" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a
          :href="agreementUrl + 11"
          target="_blank"
          rel="noopener noreferrer"
          >{{ agreementUrl + 11 }}</a
        >
      </el-form-item>
      <el-form-item
        label="sdk协议"
        prop="sdkAgreementShipper"
        style="margin-right:15px"
      >
        <myEditor v-model="form.sdkAgreementShipper" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a :href="agreementUrl + 9" target="_blank" rel="noopener noreferrer">{{
          agreementUrl + 9
        }}</a>
      </el-form-item>
      <el-form-item
        label="托运人注销协议"
        style="margin-right:15px"
        prop="cancelAgreementShipper"
      >
        <myEditor v-model="form.cancelAgreementShipper" :disabled="false" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import myEditor from "@/components/MyEditor";

export default {
  name: "SiteEdit",
  components: {
    myEditor
  },
  data() {
    return {
      agreementUrl:
        this.BASE_API_URL + "agreement/agreement.html?agreementType=",
      form: {
        code: "",
        privacyAgreementShipper: "",
        cancelAgreementShipper: "",
        userAgreementShipper: "",
        logisticsAgreementShipper: "",
        sdkAgreementShipper: ""
      },
      rules: {
        privacyAgreementShipper: [
          { required: true, message: "请输入隐私协议", trigger: "blur" }
        ],
        cancelAgreementShipper: [
          { required: true, message: "请输入注销协议", trigger: "blur" }
        ],
        userAgreementShipper: [
          { required: true, message: "请输入服务协议", trigger: "blur" }
        ],
        logisticsAgreementShipper: [
          { required: true, message: "请输入物流运输协议", trigger: "blur" }
        ],
        sdkAgreementShipper: [
          { required: true, message: "请输入SDK协议", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      const rLoading = this.openLoading("获取数据中...");
      return request({
        url: `/ntocc-basic-api/agreement/getAgreement`,
        params: { agreementType: 3 },
        method: "get"
      }).then(response => {
        if (response.data) {
          this.form.code = response.data.code;
          this.form.privacyAgreementShipper =
            response.data.privacyAgreementShipper;
          this.form.cancelAgreementShipper =
            response.data.cancelAgreementShipper;
          this.form.userAgreementShipper = response.data.userAgreementShipper;
          this.form.logisticsAgreementShipper =
            response.data.logisticsAgreementShipper;
          this.form.sdkAgreementShipper = response.data.sdkAgreementShipper;
        }
        rLoading.close();
      });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/agreement/saveAgreement",
            method: "post",
            data
          }).then(response => {
            this.getInfo();
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
